module.exports = __webpack_public_path__ + "img/A-titile-02.23f286f5.png";